// AI Generated Component
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { MonNumberPipe } from '@monsido/core/locale/pipes/mon-number.pipe';
import { StateService } from '@uirouter/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { PagesFilesPagesComponent } from '@client/app/components/pages/files/pages/pages.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

/**
 * Inventory content documents no scan component
 */
@Component({
    selector: 'inventory-content-documents-no-scan',
    templateUrl: './inventory-content-documents-no-scan.component.html',
    standalone: false,
})
export class InventoryContentDocumentsNoScanComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    // Properties matching original component
    public links: any = [];
    public subheaderTranslation: string = '';
    public tabs: any[] = [];
    public promise: Promise<any> | null = null;
    public domainId: string = '';
    public scanDocuments: boolean = false;

    constructor (
        private linksRepoService: LinksRepoService,
        private translateService: TranslateService,
        private monNumberPipe: MonNumberPipe,
        private stateService: StateService,
    ) {
        super({ table: true, pages: true });
    }

    ngOnInit (): void {
        this.initializeComponent();
    }

    ngOnDestroy (): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initializeComponent (): void {
        this.links = [];
        this.search = '';
        this.domainId = this.stateService.params.domainId;
        this.scanDocuments = this.sessionService.domain?.scan?.scan_documents || false;
        this.activeTab = 'documents';
        this.subheaderTranslation = '';
        this.setupTabs();
        this.getPage();
    }

    public override getPage (): void {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search,
            type: this.activeTab || null,
            relation: 'internal',
            page_fixed: false,
            status: 'active',
        };

        this.promise = this.linksRepoService.getAll(params).then((data) => {
            this.links = data;
            this.getSubHeaderDescription();
        });
    }

    private getSubHeaderDescription (): void {
        const total = Number(this.links.total) || 0;
        const formattedNumber = this.monNumberPipe.transform(total, '0,0');
        this.subheaderTranslation = this.translateService.getPlural(
            total,
            '1 content',
            '[[count]] content',
            { count: formattedNumber },
            '',
        );
    }

    public openDialog (link: any, type?: string): void {
        const params = {
            body: PagesFilesPagesComponent,
            size: 'lg',
            data: { link: link, domainId: this.domainId, active: 'links', icon: 'fas fa-link', type: type },
        };

        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    private setupTabs (): void {
        this.tabs = [
            {
                name: this.translateService.getString('All'),
                value: 'documents',
                faIcon: 'fas fa-file-alt',
            },
            {
                name: this.translateService.getString('PDF'),
                value: 'pdf',
                faIcon: 'fas fa-file-pdf',
            },
            {
                name: this.translateService.getString('Spreadsheets'),
                value: 'spreadsheet',
                faIcon: 'fas fa-file-excel',
            },
            {
                name: this.translateService.getString('Text Documents'),
                value: 'document',
                faIcon: 'fas fa-file-alt',
            },
        ];
    }
}
